import { GoogleIdentity } from "view/SignUp/SignUpToken/context/types";

/**
 * Decides which address a submitted step carries.
 *
 * A connected Google account overrides the field, because that address is the
 * verified one and the API takes it from the token anyway. With no account
 * connected the submitted value stands untouched — reading the fallback from
 * anywhere other than the form itself is how the typed address once got
 * replaced by a stale empty one, which the API then refused.
 */
export const applyGoogleEmail = <T extends { email: string }>(
  values: T,
  googleIdentity: GoogleIdentity | null
): T => (googleIdentity ? { ...values, email: googleIdentity.email } : values);

export default applyGoogleEmail;
